import { render, staticRenderFns } from "./ag-header-with-spinner.vue?vue&type=template&id=a09fbade&scoped=true"
import script from "./ag-header-with-spinner.vue?vue&type=script&lang=js"
export * from "./ag-header-with-spinner.vue?vue&type=script&lang=js"
import style0 from "./ag-header-with-spinner.vue?vue&type=style&index=0&id=a09fbade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09fbade",
  null
  
)

export default component.exports